'use client';

import type { FC } from 'react';
import { Skeleton } from '../ui';

const CASE_SLOT_COUNT = 3;
const PLAYER_SLOT_COUNT = 4;

export const BattleCardSkeleton: FC = () => (
  <div className="rounded-3xl bg-bg-secondary p-3 flex flex-col gap-2.5" data-testid="battle-card-skeleton">
    <div className="flex items-center justify-between gap-3 px-1">
      <Skeleton className="h-[24px] w-24 rounded-full" />
      <Skeleton className="h-[16px] w-20 rounded-md" />
    </div>
    <div className="flex items-center justify-between gap-3 px-1">
      <Skeleton className="h-[27px] w-32 rounded-lg" />
      <Skeleton className="h-[18px] w-10 rounded-md" />
    </div>

    <div className="flex gap-2 overflow-x-auto overflow-y-hidden [-webkit-overflow-scrolling:touch] -mx-1 px-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {Array.from({ length: CASE_SLOT_COUNT }).map((_, i) => (
        <Skeleton key={i} className="w-[112px] h-[112px] rounded-2xl shrink-0" />
      ))}
    </div>


    <div className="flex items-end justify-between gap-3 px-1 pb-2.5">
      <div className="flex flex-col items-start gap-2">
        <div className="flex items-end gap-2">
          {Array.from({ length: PLAYER_SLOT_COUNT }).map((_, i) => (
            <Skeleton key={i} className="size-8 rounded-full shrink-0" />
          ))}
        </div>
        <Skeleton className="h-6 w-24 rounded-full" />
      </div>
      <Skeleton className="h-9 w-16 rounded-full shrink-0" />
    </div>
  </div>
);
